var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 15.333,
    fill: "#92FBD0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.03 10.52c.62-1.91 3.32-1.91 3.94 0l1.728 5.318a2.072 2.072 0 0 0 1.97 1.432h5.593c2.007 0 2.841 2.568 1.218 3.748l-4.525 3.287a2.072 2.072 0 0 0-.752 2.316l1.728 5.319c.62 1.909-1.565 3.496-3.188 2.316l-4.525-3.287a2.072 2.072 0 0 0-2.435 0l-4.524 3.287c-1.624 1.18-3.809-.407-3.189-2.316l1.728-5.319a2.072 2.072 0 0 0-.752-2.316l-4.525-3.287c-1.623-1.18-.789-3.748 1.218-3.748h5.593c.897 0 1.693-.578 1.97-1.432l1.728-5.318z",
    fill: "#14CC81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeStar);
export default __webpack_public_path__ + "static/media/homeStar.0efbf4009eb997c895c62528de4f9761.svg";
export { ForwardRef as ReactComponent };